import React from "react"
import AccountComponent from "../components/Account/Setting"

const AccountView = () => <AccountComponent />

export default AccountView
